import React from 'react';
import ServiceBookingPage from '../ServiceBookingPage';

const packs = [
  {
    id: 'streaming_small',
    emoji: '🥉',
    name: 'Streaming Small',
    description: '3h total | 2h live | 1 platform',
    price: 7000000,
    duration: '3 hours',
    features: ['1 streaming platform', 'Dedicated technician', 'Internet backup', 'Recording delivered']
  },
  {
    id: 'streaming_medium',
    emoji: '🥈',
    name: 'Streaming Medium',
    description: '7h total | 4h live | 2 platforms',
    price: 13000000,
    duration: '7 hours',
    popular: true,
    features: ['2 simultaneous platforms', 'Real-time slides', 'Professional graphics', 'HD recording delivered']
  },
  {
    id: 'streaming_full',
    emoji: '🥇',
    name: 'Streaming Full Day',
    description: '10h total | 6h live | Unlimited platforms',
    price: 22000000,
    duration: '10 hours',
    features: ['Unlimited platforms', 'Complete graphics control', '2 dedicated technicians', 'Edited replay within 48h']
  }
];

const addons = [
  { id: 'youtube', name: 'YouTube', price: 0 },
  { id: 'facebook', name: 'Facebook', price: 0 },
  { id: 'linkedin', name: 'LinkedIn', price: 0 },
  { id: 'instagram', name: 'Instagram Live', price: 0 },
  { id: 'zoom', name: 'Zoom Webinar', price: 0 }
];

const customFields = [
  { id: 'event_type', label: 'Type of event / webinar', type: 'text', placeholder: 'Course launch, Q&A, conference...' },
  { id: 'expected_duration', label: 'Expected live duration', type: 'text', placeholder: '2 hours' },
  { id: 'num_speakers', label: 'Number of speakers', type: 'number', placeholder: '1' },
  { id: 'expected_audience', label: 'Expected audience size', type: 'text', placeholder: '100-500 viewers' }
];

export default function LiveStreamingBookingPage() {
  return (
    <ServiceBookingPage
      serviceType="live_streaming"
      serviceTitle="Live Streaming"
      serviceSubtitle="Webinars & online events"
      packs={packs}
      addons={addons}
      customFields={customFields}
      backLink="/services/live-streaming"
    />
  );
}
